<template>
  <div v-loading.fullscreen="loading" class="page-wrap">
    <el-row style="padding: 10px">
      <el-col :xs="24" :sm="24" :lg="22" :xl="20">
        <el-form
            label-position="top"
            size="large"
            :model="form"
            :rules="rules"
            ref="formRef"
        >
          <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :lg="12" :xl="12">
                          <el-form-item label="Tashabbus nomi" prop="object_name">
                            <el-input
                                disabled
                                v-model="form.object_name"
                                placeholder="Tashabbus nomi"
                            />
                          </el-form-item>
                        </el-col>

            <!-- <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Mijoz ismi" prop="customer_name">
                <el-input
                    v-model="form.customer_name"
                    placeholder="Mijoz ismi"
                />
              </el-form-item>
            </el-col> -->

            <el-col :xs="24" :sm="24" :lg="12" :xl="12" v-if="!$route.query.tin">
              <el-form-item label="Mijoz INN" prop="customer_inn">
                <el-input-number
                    controls-position="right"
                    placeholder="INN raqami"
                    style="width: 100%"
                    v-model="form.customer_inn"
                />
              </el-form-item>
            </el-col>

            <!--            <el-col :xs="24" :sm="24" :lg="12" :xl="12">-->
            <!--              <el-form-item label="Soato" prop="soato">-->
            <!--                <el-select-->
            <!--                    class="form-select"-->
            <!--                    v-model="form.soato"-->
            <!--                    placeholder="Tanlang"-->
            <!--                >-->
            <!--                  <el-option-->
            <!--                      v-for="type in soato_list"-->
            <!--                      :value="type.id"-->
            <!--                      :key="type.id"-->
            <!--                      :label="type.title"-->
            <!--                  />-->
            <!--                </el-select>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->

            <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Sfera" prop="sphere_id">
                <el-select
                    disabled
                    class="form-select"
                    v-model="form.sphere_id"
                    @change="handleSphere"
                    placeholder="Tanlang"
                >
                  <el-option
                      v-for="type in spheres_list"
                      :value="type.id"
                      :key="type.id"
                      :label="type.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Tarmoq turi" prop="network_id">
                <el-select
                    disabled
                    class="form-select"
                    v-model="form.network_id"
                    placeholder="Tanlang"
                >
                  <el-option
                      v-for="type in networks"
                      :value="type.id"
                      :key="type.id"
                      :label="type.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Ish turi" prop="construction_type_id">
                <el-select
                    :disabled="constructionSelectDisabled"
                    class="form-select"
                    v-model="form.construction_type_id"
                    placeholder="Tanlang"
                >
                  <el-option
                      v-for="type in construction_types_new"
                      :value="type.id"
                      :key="type.id"
                      :label="type.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Prognoz" prop="forecast">
                <el-input
                    placeholder="Prognoz"
                    v-model="form.forecast"
                    v-money="money"
                />
              </el-form-item>
            </el-col> -->
            <!-- <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Quvvat turi" prop="object_power">
                <el-select
                    class="form-select"
                    v-model="form.object_power"
                    placeholder="Tanlang"
                >
                  <el-option
                      v-for="type in object_power_types"
                      :value="type.id"
                      :key="type.id"
                      :label="type.title"
                  />
                </el-select>
              </el-form-item>
            </el-col> -->

            <!-- <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Quvvat soni" prop="object_power_count">
                <el-input
                    placeholder="Quvvat soni"
                    v-model="form.object_power_count"
                    v-money="money"
                />
              </el-form-item>
            </el-col> -->

            <!-- <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Xarajat turi" prop="expense_type_id">
                <el-select
                    class="form-select"
                    v-model="form.expense_type_id"
                    placeholder="Tanlang"
                >
                  <el-option
                      v-for="type in expense_types"
                      :value="type.id"
                      :key="type.id"
                      :label="type.title"
                  />
                </el-select>
              </el-form-item>
            </el-col> -->

            <!-- <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item
                  label="Moliyalashtirish manbai"
                  prop="funding_source_id"
              >
                <el-select
                    class="form-select"
                    v-model="form.funding_source_id"
                    placeholder="Tanlang"
                >
                  <el-option
                      v-for="type in funding_sources"
                      :value="type.id"
                      :key="type.id"
                      :label="type.title"
                  />
                </el-select>
              </el-form-item>
            </el-col> -->

            <el-col :xs="24" :sm="24" :lg="12" :xl="12">
              <el-form-item label="Vazirlik" prop="ministry_id">
                <el-select
                    disabled
                    class="form-select"
                    v-model="form.ministry_id"
                    placeholder="Tanlang"
                >
                  <el-option
                      v-for="type in ministries"
                      :value="type.id"
                      :key="type.id"
                      :label="type.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :lg="12" :xl="12" v-if="!['CONSTRUCTION','EQUIPMENT'].includes(constructionType)">
              <el-form-item label="Qurilish turi" prop="work_type_id">
                <el-select
                    class="form-select"
                    v-model="form.work_type_id"
                    placeholder="Tanlang"
                >
                  <el-option
                      v-for="type in work_types"
                      :value="type.id"
                      :key="type.id"
                      :label="type.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <!--            <el-col :xs="24" :sm="24" :lg="12" :xl="12">-->
            <!--              <el-form-item-->
            <!--                  label="Amalga oshirish boshlangan yili"-->
            <!--                  prop="execution_begin_year"-->
            <!--              >-->
            <!--                <el-date-picker-->
            <!--                    placeholder="Sana tanlang"-->
            <!--                    style="width: 100%"-->
            <!--                    v-model="form.execution_begin_year"-->
            <!--                    type="year"-->
            <!--                />-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <!--            <el-col :xs="24" :sm="24" :lg="12" :xl="12">-->
            <!--              <el-form-item-->
            <!--                  label="Amalga oshirish tugatilgan yili"-->
            <!--                  prop="execution_end_year"-->
            <!--              >-->
            <!--                <el-date-picker-->
            <!--                    placeholder="Sana tanlang"-->
            <!--                    style="width: 100%"-->
            <!--                    v-model="form.execution_end_year"-->
            <!--                    type="year"-->
            <!--                />-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->

            <el-col :xs="24" :sm="18" :lg="16" :xl="14">
              <el-form-item>
                <el-button @click="$router.go(-1)">Ortga</el-button>
                <el-button type="primary" @click="onSubmit">Jonatish</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {ElNotification} from "element-plus";
import {DocumentAdd} from "@element-plus/icons-vue";

import {
  soato_list,
  spheres_list,
  networks_list,
  construction_types,
  object_power_types,
  expense_types,
  funding_sources,
  ministries,
  work_types,
  categoryWithIds,
  construction_types_new,
} from "@/views/newchronology/ChronologyConstants";
import moment from "moment";

export default {
  name: "NewChronologyForm",
  data() {
    return {
      loading: false,
      showEditButton: false,
      chronologyList: [],
      activeName: 1,
      soato_list,
      spheres_list,
      DocumentAdd,
      networks: [],
      construction_types,
      construction_types_new,
      object_power_types,
      expense_types,
      funding_sources,
      ministries,
      work_types,
      form: {
        openbudget_id: null,
        object_name: "",
        soato: null,
        construction_type_id: null,
        group_program_id: 3,
        // sphere_id: null,
        // network_id: null,
        forecast: this.$route.query.granted_amount,
        customer_inn: null,
        customer_name: "",
        execution_begin_year: 2025,
        execution_end_year: null,
        periodicity_id: 1,
        periodicity_name: "Янги",
        project_status_id: 1,
        project_status_name: "Бошланмаган",
        object_power: 1,
        object_power_count: 1,
        // ministry_id: null,
        funding_source_id: 2,
        work_type_id: null,
        expense_type_id: 1,
      },

      rules: {
        ministry_id: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
        funding_source_id: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
        work_type_id: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
        expense_type_id: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
        object_name: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
        object_power: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
        object_power_count: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
        soato: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
        construction_type_id: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
        sphere_id: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
        network_id: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
        forecast: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
        customer_inn: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
        customer_name: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
        execution_begin_year: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
        execution_end_year: [
          {
            required: true,
            message: "Majburiy maydon.",
          },
        ],
      },

      money: {
        decimal: ".",
        thousands: " ",
        prefix: "",
        suffix: "",
        precision: 0,
      },
      constructionType: null,
      category: null,
      constructionSelectDisabled: true
    };
  },
  methods: {
    toggleAddInvest() {
      this.showAddingInvest = !this.showAddingInvest;
    },
    handleShowEditBtn(object_id) {
      const data = this.chronologyList.find(
          (item) => item.object_id == object_id
      );
      if (data) {
        data.disabled = false;
        data.showEditButton = false;
        console.log(data, "hi");
      }
    },
    editInvestIdInfo(id) {
      console.log(id, "id");
      const data = this.chronologyList.find((item) => item.object_id == id);
      if (data) {
        data.disabled = true;
        data.showEditButton = true;
        console.log(data, "bye");
      }
    },
    getByInvestId() {
      this.loading = true;
      this.$http
          .get(`api/v1/chronology?public_id=${this.form.openbudget_id}`)
          .then(({data}) => {
            console.log(data);
            this.chronologyList = data.map((item) => {
              return {...item, disabled: true, showEditButton: true};
            });
            ElNotification.success({
              message: "Success",
            });
          })
          .catch((error) => {
            console.log(error);
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          const formData = {
            ...this.form,
            object_name: this.form.object_name.slice(0, 255),
            customer_inn: this.form.customer_inn.toString(),
            forecast: parseFloat(this.form.forecast.replace(/\s/g, "")),
            execution_begin_year: new Date(
                this.form.execution_begin_year
            ).getFullYear(),
            execution_end_year: new Date(
                this.form.execution_end_year
            ).getFullYear(),
            object_power: [
              {
                powerId: this.form.object_power,
                powerName: this.object_power_types.find(
                    (item) => item.id === this.form.object_power
                )?.title,
                value: this.form.object_power_count,
              },
            ],
          };
          delete formData.object_power_count;
          this.$http
              .post(`/api/v1/chronology/invest/`, formData)
              .then(() => {
                this.$router.go(-1);
                ElNotification.success({
                  message: "Success",
                });
              })
              .catch((error) => {
                console.log(error.response.data.error.message);
                ElNotification.error({
                  message:
                      (error.response.data.error.message === 'PROJECT NOT FOUND' ? "Mijoz topilmadi" : error.response.data.message) ||
                      "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      });
    },
    handleSphere(e) {
      this.networks = [];
      this.form.network_id = null;
      if (e) {
        this.networks = networks_list.filter((item) => item.sphere_id === e);
      }
    },
  },
  mounted() {
    this.form.openbudget_id = this.$route.params.public_id;
    this.form.object_name = this.$route.query.desc;
    this.form.soato = this.$route.query.soato;
    this.form.customer_inn = this.$route.query.tin;
    this.constructionType = this.$route.query.type;
    this.category = this.$route.query.category;

    this.handleSphere(categoryWithIds[this.category]?.sphere_id);

    if (this.category === 18) {
      this.form.construction_type_id = 2
    } else {
      if (this.constructionType === 'CONSTRUCTION') {
        this.form.construction_type_id = 9
      } else if (this.constructionType === 'EQUIPMENT') {
        this.form.construction_type_id = 7
      } else {
        this.form.construction_type_id = null
        this.constructionSelectDisabled = false
      }
    }

    this.form = {...this.form, ...categoryWithIds[this.category]}

    if (this.constructionType === 'CONSTRUCTION') {
      this.form.work_type_id = 1
    }
    if (this.constructionType === 'EQUIPMENT') {
      this.form.work_type_id = 2
    }
    this.form.execution_begin_year = moment(new Date()).format("YYYY");
    this.form.execution_end_year = moment(new Date()).format("YYYY");
  },
};
</script>

<style scoped>
.form-select {
  width: 100%;
}
</style>
